import React, { useState } from "react"
import {Link} from "gatsby"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faInstagram,
  faLinkedin,
  faTwitter,
  faGithub
} from "@fortawesome/free-brands-svg-icons"
import "./footer.css"



export const Footer = () => {
  return (

    <footer id="footer" className="footer-area bg-red-900 max-h-20">
        <div className="footer-widget pt-0 pb-0">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-8">
                        <div className="footer-content text-center align-content-sm-center">
                            
                            
                            <Link to="https://github.com/GaneshPandey-GP" target="_blank" className="mx-2 lg:mx-5"> <FontAwesomeIcon  icon={faGithub} size="lg"  role="button" aria-label="Facebook"/></Link>
                            <Link to="https://www.linkedin.com/in/ganesh-pandey-1426b4171/" target="_blank" className="mx-2 lg:mx-5"> <FontAwesomeIcon  icon={faLinkedin} size="lg"  role="button" aria-label="Facebook"/></Link>
                            <Link to="https://twitter.com/GaneshpandeyG" target="_blank" className="mx-2 lg:mx-5"> <FontAwesomeIcon icon={faTwitter} size="lg"  role="button" aria-label="Facebook"/></Link>
                            <Link to="https://www.instagram.com/ganesh.pandey.179/" target="_blank" className="mx-2 lg:mx-5"> <FontAwesomeIcon   icon={faInstagram} size="lg"  role="button" aria-label="Facebook"/></Link>
                            <div className="copyright-text text-center -pt-10 d-sm-none d-lg-block">
                            <p> Made By- Ganesh | Copyright © {(new Date().getFullYear())}</p>
                        </div>
                                
                            
                        </div> 
                    </div>
                </div> 
            </div> 
        </div> 
        {/* <div className="footer-copyright pb-20">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="copyright-text text-center pt-20 d-sm-none d-lg-block">
                            <p>Copyright © 2021 Ganesh</p>
                        </div> 
                    </div>
                </div> 
            </div> 
        </div>  */}
    </footer>
  )
}
